import service from "@/store/services/notificaciones-service";

const state = {
  list: {},
  notificacion: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, notificacion) => {
    state.notificacion = notificacion;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then((notificacion) => {
      commit("SET_RESOURCE", notificacion);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then((notificacion) => {
      commit("SET_RESOURCE", notificacion);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then((notificacion) => {
      commit("SET_RESOURCE", notificacion);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.pagination.total,
  notificacion: (state) => state.notificacion,
  dropdown: (state) => {
    /*  state.list.map((notificacion) => console.log(notificacion)); */
    return state.list.map((notificacion) => ({
      id: notificacion.id,
      nombre: notificacion.nombre,
    }));
  },
};

const notificaciones = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default notificaciones;
